import React from 'react'
import SimpleForm from './SimpleForm'
import StepperForm from './StepperForm'
import { Breadcrumb, SimpleCard } from 'app/components'
import { Box, styled } from '@mui/system'

const Container = styled('div')(({ theme }) => ({
    margin: '30px',
    [theme.breakpoints.down('sm')]: {
        margin: '16px',
    },
    '& .breadcrumb': {
        marginBottom: '30px',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '16px',
        },
    },
}))

const AppForm = () => {
    return (
        <Container>
            <div className="breadcrumb">
                <Breadcrumb
                    routeSegments={[
                        { name: 'Material', path: '/material' },
                        { name: 'Form' },
                    ]}
                />
            </div>
            <SimpleCard title="Simple Form">
                <SimpleForm />
            </SimpleCard>
            <Box py="12px" />
            <SimpleCard title="stepper form">
                <StepperForm />
            </SimpleCard>
        </Container>
    )
}

export default AppForm
